(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minevre-client-reviews"]) return;
  try {
    
  if (!customElements.get('mnv-review-behavior')) {
    class MnvReviewBehavior extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.mnv-reviews');
        if (!this.root) return;
        const grid = this.root.querySelector('.mnv-reviews__grid');
        const previous = this.root.querySelector('.mnv-reviews__prev');
        const next = this.root.querySelector('.mnv-reviews__next');
        const all = this.root.querySelector('.mnv-reviews__all');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const update = () => {
          previous.disabled = grid.scrollLeft <= 2;
          next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
        };
        const move = (direction) => {
          const cards = [...grid.children];
          const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : grid.clientWidth;
          const index = Math.round(grid.scrollLeft / step) + direction;
          grid.scrollTo({ left: Math.max(0, index * step), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        grid.addEventListener('scroll', update, { ...options, passive: true });
        all?.addEventListener('click', () => {
          this.root.classList.add('is-expanded');
          all.setAttribute('aria-expanded', 'true');
          const sixth = grid.children[5];
          sixth?.setAttribute('tabindex', '-1');
          sixth?.focus({ preventScroll: true });
        }, options);
        this.root.classList.add('is-ready');
        this.observer = new ResizeObserver(update);
        this.observer.observe(grid);
        update();
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    }
    customElements.define('mnv-review-behavior', MnvReviewBehavior);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minevre-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-mnv-site-footer]').forEach((root) => {
        if (root.dataset.mnvInitialized === 'true') return;
        root.dataset.mnvInitialized = 'true';
        const media = window.matchMedia('(max-width: 749px)');
        const groups = [...root.querySelectorAll('.mnv-site-footer__group')];
        const sync = () => groups.forEach((group) => { group.open = !media.matches; });
        sync();
        media.addEventListener('change', sync);
        /* Fit the actual font size before centering. Scaling an overflowing
           max-content span moved its visual center away from the mobile box. */
        const textLogo = root.querySelector('.mnv-site-footer__logo-text');
        const logoHolder = root.querySelector('.mnv-site-footer__logo');
        if (textLogo && logoHolder) {
          const fitTextLogo = () => {
            textLogo.style.fontSize = '';
            if (!media.matches) return;
            const available = Math.max(1, logoHolder.clientWidth);
            const naturalWidth = Math.max(1, textLogo.scrollWidth);
            const naturalSize = parseFloat(getComputedStyle(textLogo).fontSize);
            if (naturalWidth > available) {
              textLogo.style.fontSize = `${naturalSize * available / naturalWidth}px`;
            }
          };
          fitTextLogo();
          media.addEventListener('change', fitTextLogo);
          window.addEventListener('resize', fitTextLogo, { passive: true });
          if (document.fonts?.ready) document.fonts.ready.then(fitTextLogo);
        }
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minevre-immersive-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-minevre-immersive]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      // Narrow screens read the editorial stream; desktop keeps the original immersive sequence.
      const originalScreens = [...root.querySelectorAll('[data-immersive-screen]')];
      const editorialScreens = [...root.querySelectorAll('[data-safari-editorial], .minevre-screen--footer')];
      const useMobileEditorials = () => window.matchMedia('(max-width: 749px)').matches;
      let screens = useMobileEditorials() ? editorialScreens : originalScreens;
      const header = root.querySelector('[data-immersive-header]');
      const wordmark = root.querySelector('[data-immersive-logo]');
      const logoLayers = [...root.querySelectorAll('[data-logo-index]')];
      const footerGroups = [...root.querySelectorAll('.minevre-footer__group')];
      const footerScreen = screens.find((screen) => screen.classList.contains('minevre-screen--footer'));
      const footerWordmark = footerScreen?.querySelector('[data-footer-wordmark]');
      const stage = root.querySelector('[data-immersive-stage]');
      let logoBridge = null;
      let logoBridgeAnimation = null;
      let handoffId = 0;
      let logoHandoffFrame = null;
      let logoRevealFrame = null;
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const syncFooterGroups = () => footerGroups.forEach((group) => { group.open = !mobileQuery.matches; });
      syncFooterGroups();
      mobileQuery.addEventListener('change', syncFooterGroups);
      const logoImages = logoLayers.map((layer) => {
        const image = new Image();
        image.src = layer.dataset.logoUrl;
        return image;
      });
      /* Resolve the logo chosen for EACH screen before removing duplicate mask nodes.
         The previous version discarded these choices and kept the screen-1 art on
         screen 3, making the image picker appear broken. A single mask remains
         mounted, and its source changes only if a screen actually chooses a
         different image. Color continues to come from the header theme. */
      const logoForScreen = new Map(logoLayers.map((layer) => [
        Number(layer.dataset.logoIndex),
        { url: layer.dataset.logoUrl, mask: layer.style.getPropertyValue('--logo-mask'), ratio: layer.dataset.logoRatio }
      ]));
      const persistentLogoLayer = logoLayers[0] || null;
      const textNode = wordmark.querySelector('.minevre-wordmark__text');
      logoLayers.forEach((layer) => {
        if (layer !== persistentLogoLayer) layer.remove();
      });
      let activeLogoUrl = persistentLogoLayer?.dataset.logoUrl || '';
      const syncLogo = (screenIndex) => {
        const selected = logoForScreen.get(screenIndex);
        const source = selected?.url || '';
        if (persistentLogoLayer) {
          persistentLogoLayer.style.opacity = source ? '1' : '0';
          if (source && source !== activeLogoUrl) {
            persistentLogoLayer.style.setProperty('--logo-mask', selected.mask);
            persistentLogoLayer.dataset.logoUrl = source;
            activeLogoUrl = source;
          }
        }
        /* A section-specific logo can have a different canvas ratio from page 1.
           Match its actual ratio before measuring the compact destination. */
        if (source && selected?.ratio) wordmark.style.setProperty('--wordmark-ratio', selected.ratio);
        wordmark.classList.toggle('has-image', Boolean(source));
        if (textNode) textNode.hidden = Boolean(source);
      };
      /* Measure the footer logo at its RESTING position even while its screen is
         translated offscreen. The shared element lives outside both moving screens. */
      const footerWordmarkRect = () => {
        if (!footerWordmark || !footerScreen || !stage) return null;
        const art = footerWordmark.querySelector('img, span') || footerWordmark;
        const bounds = art.getBoundingClientRect();
        const movingScreen = footerScreen.getBoundingClientRect();
        const stageBounds = stage.getBoundingClientRect();
        const image = art.tagName === 'IMG' ? art : null;
        const ratio = image && image.naturalWidth && image.naturalHeight
          ? image.naturalWidth / image.naturalHeight
          : Number.parseFloat(footerWordmark.dataset.footerLogoRatio) || 5;
        const width = image ? Math.min(bounds.width, bounds.height * ratio) : bounds.width;
        const height = image ? width / ratio : bounds.height;
        return {
          left: bounds.left + (bounds.width - width) / 2 - (movingScreen.left - stageBounds.left),
          top: bounds.top - (movingScreen.top - stageBounds.top),
          width,
          height
        };
      };

      /* On a reverse navigation, reading getBoundingClientRect() immediately
         after a responsive logo/ratio change can capture the old/interpolated
         rectangle. The bridge must target the final compact rectangle, not a
         transient one. The normal logo is hidden during this measurement. */
      const settledCompactHeaderRect = () => {
        const previousTransition = wordmark.style.getPropertyValue('transition');
        const previousPriority = wordmark.style.getPropertyPriority('transition');
        wordmark.style.setProperty('transition', 'none', 'important');
        const rect = wordmark.getBoundingClientRect();
        if (previousTransition) {
          wordmark.style.setProperty('transition', previousTransition, previousPriority);
        } else {
          wordmark.style.removeProperty('transition');
        }
        return rect;
      };

      const validRect = (rect) => rect &&
        ['left', 'top', 'width', 'height'].every((key) => Number.isFinite(rect[key])) &&
        rect.width > 0 && rect.height > 0;

      const clearLogoBridge = () => {
        handoffId += 1;
        if (logoHandoffFrame !== null) cancelAnimationFrame(logoHandoffFrame);
        if (logoRevealFrame !== null) cancelAnimationFrame(logoRevealFrame);
        logoHandoffFrame = null;
        logoRevealFrame = null;
        const oldAnimation = logoBridgeAnimation;
        logoBridgeAnimation = null;
        logoBridge?.remove();
        logoBridge = null;
        root.classList.remove('is-logo-handoff');
        header.style.removeProperty('opacity');
        header.style.removeProperty('visibility');
        header.style.removeProperty('transition');
        oldAnimation?.cancel();
      };

      const makeLogoBridge = (from, destination, color, headerArtwork) => {
        const art = footerWordmark?.querySelector('img, span');
        if (!art || !validRect(from) || !validRect(destination)) return null;
        const bridge = document.createElement('span');
        bridge.className = 'minevre-logo-bridge';
        bridge.setAttribute('aria-hidden', 'true');
        bridge.style.cssText = 'position:fixed;display:block;top:0;left:0;z-index:2147483000;margin:0;pointer-events:none;transform-origin:top left;max-width:none;max-height:none;box-sizing:border-box;';
        bridge.style.width = `${from.width}px`;
        bridge.style.height = `${from.height}px`;
        bridge.style.left = `${from.left}px`;
        bridge.style.top = `${from.top}px`;
        bridge.style.color = color || getComputedStyle(wordmark).color;

        const footerArt = art.cloneNode(true);
        footerArt.className = 'minevre-logo-bridge__footer';
        footerArt.removeAttribute('hidden');
        footerArt.style.cssText = 'position:absolute;inset:0;display:block;width:100%;height:100%;max-width:none;max-height:none;margin:0;padding:0;box-sizing:border-box;';
        if (art.tagName === 'IMG') {
          footerArt.removeAttribute('srcset');
          footerArt.removeAttribute('sizes');
          footerArt.src = art.currentSrc || art.src;
          footerArt.loading = 'eager';
          footerArt.style.objectFit = 'fill';
          footerArt.style.filter = getComputedStyle(art).filter;
        } else {
          const typography = getComputedStyle(art);
          footerArt.style.fontFamily = typography.fontFamily;
          footerArt.style.fontSize = typography.fontSize;
          footerArt.style.fontWeight = typography.fontWeight;
          footerArt.style.lineHeight = typography.lineHeight;
          footerArt.style.letterSpacing = typography.letterSpacing;
          footerArt.style.textAlign = typography.textAlign;
          footerArt.style.whiteSpace = 'nowrap';
        }
        bridge.appendChild(footerArt);

        /* Both logos occupy the same moving rectangle. Fade their artwork while
           that rectangle scales, so switching PNG and header mask cannot jump. */
        const maskImage = headerArtwork?.maskImage;
        if (headerArtwork?.hasImage && maskImage && maskImage !== 'none') {
          const headerArt = document.createElement('span');
          headerArt.className = 'minevre-logo-bridge__header';
          headerArt.style.cssText = 'position:absolute;inset:0;display:block;width:100%;height:100%;background-color:currentColor;';
          headerArt.style.maskImage = maskImage;
          headerArt.style.webkitMaskImage = maskImage;
          headerArt.style.maskSize = '100% 100%';
          headerArt.style.webkitMaskSize = '100% 100%';
          headerArt.style.maskPosition = 'center';
          headerArt.style.webkitMaskPosition = 'center';
          headerArt.style.maskRepeat = 'no-repeat';
          headerArt.style.webkitMaskRepeat = 'no-repeat';
          bridge.appendChild(headerArt);
          const enteringFooter = root.classList.contains('is-footer-active');
          headerArt.style.opacity = enteringFooter ? '1' : '0';
          footerArt.style.opacity = enteringFooter ? '0' : '1';
        }
        document.body.appendChild(bridge);
        return bridge;
      };

      const animateFooterLogo = (from, destination, fromColor, toColor, headerArtwork) => {
        if (!validRect(from) || !validRect(destination) || !footerWordmark ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          clearLogoBridge();
          return;
        }
        clearLogoBridge();
        const bridge = makeLogoBridge(from, destination, fromColor, headerArtwork);
        if (!bridge) return;
        logoBridge = bridge;
        const thisHandoff = handoffId;
        /* Suppress the two native logos ONLY AFTER the shared artwork is mounted. */
        root.classList.add('is-logo-handoff');
        const speed = Number.parseInt(getComputedStyle(root).getPropertyValue('--transition-speed'), 10) || 500;
        const geometryAt = (rect, color) => ({
          left: `${rect.left}px`,
          top: `${rect.top}px`,
          width: `${rect.width}px`,
          height: `${rect.height}px`,
          color
        });
        const animation = bridge.animate([
          geometryAt(from, fromColor),
          geometryAt(destination, toColor)
        ], {
          duration: speed,
          easing: 'cubic-bezier(.76, 0, .24, 1)',
          fill: 'forwards'
        });
        logoBridgeAnimation = animation;
        const headerArt = bridge.querySelector('.minevre-logo-bridge__header');
        const footerArt = bridge.querySelector('.minevre-logo-bridge__footer');
        if (headerArt && footerArt) {
          const enteringFooter = root.classList.contains('is-footer-active');
          const artworkTiming = {
            duration: speed,
            easing: 'cubic-bezier(.76, 0, .24, 1)',
            fill: 'forwards'
          };
          headerArt.animate([
            { opacity: enteringFooter ? 1 : 0 },
            { opacity: enteringFooter ? 0 : 1 }
          ], artworkTiming);
          footerArt.animate([
            { opacity: enteringFooter ? 0 : 1 },
            { opacity: enteringFooter ? 1 : 0 }
          ], artworkTiming);
        }

        animation.addEventListener('finish', () => {
          if (thisHandoff !== handoffId) return;
          const returned = !root.classList.contains('is-footer-active');
          if (returned) {
            const fadeDuration = Math.min(220, Math.max(140, Math.round(speed * 0.32)));
            wordmark.style.setProperty('transition', 'none');
            wordmark.style.setProperty('opacity', '0');
            header.style.setProperty('transition', 'none');
            header.style.setProperty('opacity', '1');
            header.style.setProperty('visibility', 'visible');
            root.classList.remove('is-logo-handoff');
            root.classList.remove('is-return-logo-overlay');
            logoRevealFrame = requestAnimationFrame(() => {
              logoRevealFrame = null;
              if (thisHandoff !== handoffId) return;
              wordmark.style.setProperty('transition', `opacity ${fadeDuration}ms ease-out`);
              wordmark.style.setProperty('opacity', '1');
              bridge.animate([{ opacity: 1 }, { opacity: 0 }], {
                duration: fadeDuration,
                easing: 'ease-out',
                fill: 'forwards'
              }).finished.then(() => {
                if (thisHandoff !== handoffId) return;
                wordmark.style.removeProperty('opacity');
                wordmark.style.removeProperty('transition');
                clearLogoBridge();
              });
            });
            return;
          }
          /* Preserve the existing forward 3 -> footer handoff. */
          root.classList.remove('is-logo-handoff');
          logoHandoffFrame = requestAnimationFrame(() => {
            logoHandoffFrame = requestAnimationFrame(() => {
              logoHandoffFrame = null;
              if (thisHandoff !== handoffId) return;
              clearLogoBridge();
            });
          });
        }, { once: true });
      };

      const currentLabel = root.querySelector('[data-current]');
      const nextButton = root.querySelector('[data-scroll-next]');
      const menu = root.querySelector('[data-immersive-menu]');
      const menuClose = root.querySelector('[data-menu-close]');
      const cardNextButtons = [...root.querySelectorAll('[data-card-next]')];
      const cardPrevButtons = [...root.querySelectorAll('[data-card-prev]')];
      let index = 0;
      let locked = false;
      let touchStartY = 0;
      let touchStartX = 0;
      let wheelTotal = 0;
      let wheelTimer;

      const nativeStops = [...root.querySelectorAll('[data-native-index]')];
      const nativeScrollEnabled = () => mobileQuery.matches;
      const nativeTargets = () => nativeStops.length && nativeStops[0].getClientRects().length ? nativeStops : screens;
      let nativeFrame = 0;
      const updateNativeScroll = () => {
        nativeFrame = 0;
        if (!nativeScrollEnabled()) return;
        const viewportTop = window.visualViewport?.offsetTop || 0;
        const probe = viewportTop + header.offsetHeight / 2;
        let next = nativeTargets().findIndex(stop => stop.getBoundingClientRect().bottom > probe);
        if (next < 0) next = screens.length - 1;
        index = next;
        screens.forEach((screen, screenIndex) => {
          screen.dataset.state = screenIndex < index ? 'before' : screenIndex === index ? 'active' : 'after';
          screen.setAttribute('aria-hidden', 'false');
          screen.inert = false;
        });
        const theme = screens[index].dataset.theme || 'light';
        header.dataset.theme = theme;
        syncLogo(Number(screens[index].dataset.index ?? index));
        header.classList.toggle('is-compact', index > 0 || root.getBoundingClientRect().top < -40);
        const atFooter = Boolean(footerScreen && (nativeTargets() === screens ?
          footerScreen.getBoundingClientRect().top <= viewportTop + header.offsetHeight + 12 :
          screens[index] === footerScreen));
        root.classList.toggle('is-footer-active', atFooter);
        root.dataset.currentIndex = String(index);
        root.dataset.controlsTheme = theme;
        currentLabel.textContent = String(index + 1);
      };
      const requestNativeScroll = () => {
        if (nativeScrollEnabled() && !nativeFrame) nativeFrame = requestAnimationFrame(updateNativeScroll);
      };
      document.addEventListener('scroll', requestNativeScroll, { passive: true, capture: true });
      window.addEventListener('resize', requestNativeScroll, { passive: true });
      window.addEventListener('pageshow', requestNativeScroll);
      window.visualViewport?.addEventListener('resize', requestNativeScroll, { passive: true });
      let wasNativeScroll = nativeScrollEnabled();
      const syncResponsiveMode = () => {
        if (nativeScrollEnabled() === wasNativeScroll) return;
        wasNativeScroll = nativeScrollEnabled();
        syncFooterGroups();
        clearLogoBridge();
        root.classList.remove('is-return-logo-overlay');
        screens = useMobileEditorials() ? editorialScreens : originalScreens;
        index = 0;
        [...new Set([...originalScreens, ...editorialScreens])].forEach(screen => {
          const active = screens.includes(screen);
          screen.setAttribute('aria-hidden', active ? 'false' : 'true');
          screen.inert = !active;
        });
        root.dataset.currentIndex = '0';
        currentLabel.textContent = '1';
        syncLogo(0);
        root.classList.remove('is-footer-active');
        header.dataset.theme = screens[0].dataset.theme || 'light';
        root.dataset.controlsTheme = screens[0].dataset.theme || 'light';
        header.classList.remove('is-compact');
        if (nativeScrollEnabled()) {
          clearLogoBridge();
          root.classList.remove('is-return-logo-overlay');
          requestNativeScroll();
        } else {
          screens.forEach((screen, screenIndex) => {
            screen.dataset.state = screenIndex < index ? 'before' : screenIndex === index ? 'active' : 'after';
            screen.setAttribute('aria-hidden', screenIndex === index ? 'false' : 'true');
            screen.inert = screenIndex !== index;
          });
          window.scrollTo({ top: 0, behavior: 'instant' });
        }
      };
      mobileQuery.addEventListener('change', syncResponsiveMode);
      window.addEventListener('resize', syncResponsiveMode, { passive: true });

      document.body.classList.add('minevre-immersive-active');

      const setIndex = (nextIndex) => {
        const clamped = Math.max(0, Math.min(screens.length - 1, nextIndex));
        if (nativeScrollEnabled()) {
          nativeTargets()[clamped]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
          return;
        }
        if (clamped === index || locked) return;
        locked = true;
        if (root.classList.contains('is-return-logo-overlay')) {
          /* The kept image is only for the return to screen 3. Retire it at the
             start of the NEXT navigation, never at the end of 4 -> 3. */
          root.classList.remove('is-return-logo-overlay');
          clearLogoBridge();
        }
        const wasFooter = screens[index].classList.contains('minevre-screen--footer');
        const enteringFooter = !wasFooter && screens[clamped].classList.contains('minevre-screen--footer');
        const leavingFooter = wasFooter && !screens[clamped].classList.contains('minevre-screen--footer');
        if (leavingFooter) root.classList.add('is-return-logo-overlay');
        /* Read the small wordmark's geometry before its header is hidden. */
        const headerFrom = enteringFooter ? wordmark.getBoundingClientRect() : null;
        const headerArtworkFrom = enteringFooter ? {
          hasImage: wordmark.classList.contains('has-image'),
          maskImage: persistentLogoLayer && getComputedStyle(persistentLogoLayer).maskImage
        } : null;
        const headerColor = enteringFooter ? getComputedStyle(header).color : null;
        const footerFrom = leavingFooter ? footerWordmarkRect() : null;
        const footerColor = (enteringFooter || leavingFooter) && footerScreen
          ? getComputedStyle(footerScreen).color : null;
        index = clamped;

        screens.forEach((screen, screenIndex) => {
          const state = screenIndex < index ? 'before' : screenIndex === index ? 'active' : 'after';
          screen.dataset.state = state;
          screen.setAttribute('aria-hidden', screenIndex === index ? 'false' : 'true');
          if ('inert' in screen) screen.inert = screenIndex !== index;
        });

        const theme = screens[index].dataset.theme || 'light';
        header.dataset.theme = theme;
        syncLogo(index);
        header.classList.toggle('is-compact', index > 0);
        root.classList.toggle('is-footer-active', screens[index].classList.contains('minevre-screen--footer'));
        root.dataset.currentIndex = String(index);
        root.dataset.controlsTheme = theme;
        currentLabel.textContent = String(index + 1);

        if (enteringFooter || leavingFooter) {
          const compactHeader = leavingFooter ? settledCompactHeaderRect() : wordmark.getBoundingClientRect();
          const destination = enteringFooter ? footerWordmarkRect() : compactHeader;
          const from = enteringFooter ? headerFrom : footerFrom;
          const destinationColor = enteringFooter ? footerColor : getComputedStyle(header).color;
          animateFooterLogo(from, destination,
            enteringFooter ? headerColor : footerColor, destinationColor,
            enteringFooter ? headerArtworkFrom : {
              hasImage: wordmark.classList.contains('has-image'),
              maskImage: persistentLogoLayer && getComputedStyle(persistentLogoLayer).maskImage
            });
        }

        window.setTimeout(() => { locked = false; }, Number.parseInt(getComputedStyle(root).getPropertyValue('--transition-speed'), 10) + 80);
      };

      const step = (direction) => setIndex(index + direction);

      const onWheel = (event) => {
        if (nativeScrollEnabled()) return;
        if (menu?.open || root.querySelector('.mnv-editorial-drawer > details[open]')) return;
        const screen = screens[index];
        if (screen?.classList.contains('minevre-screen--footer') && (event.deltaY >= 0 || screen.scrollTop > 1)) return;
        event.preventDefault();
        if (locked) return;
        wheelTotal += event.deltaY;
        window.clearTimeout(wheelTimer);
        wheelTimer = window.setTimeout(() => { wheelTotal = 0; }, 160);
        if (Math.abs(wheelTotal) > 45) {
          step(wheelTotal > 0 ? 1 : -1);
          wheelTotal = 0;
        }
      };

      const onTouchStart = (event) => {
        touchStartY = event.touches[0].clientY;
        touchStartX = event.touches[0].clientX;
      };

      /* Chrome's native viewport pan can settle after our slide has settled,
         producing a second small movement. Consume only downward page swipes;
         Safari native scrolling, upward swipes, menus and footer stay untouched. */
      const chromeTouch = /(?:Chrome|CriOS)\//.test(navigator.userAgent) && !/(?:Edg|OPR|SamsungBrowser)/.test(navigator.userAgent);
      root.classList.toggle('mnv-chrome-swipe', chromeTouch);
      const onTouchMove = (event) => {
        if (!chromeTouch || !mobileQuery.matches || nativeScrollEnabled() || event.touches.length !== 1) return;
        if (menu?.open || root.querySelector('.mnv-editorial-drawer > details[open]') || event.target.closest('input, textarea, select, [contenteditable="true"], [role="dialog"]')) return;
        if (screens[index]?.classList.contains('minevre-screen--footer') && !locked) return;
        const dy = touchStartY - event.touches[0].clientY;
        const dx = touchStartX - event.touches[0].clientX;
        if (dy > 0 && dy > Math.abs(dx) && event.cancelable) event.preventDefault();
      };

      const onTouchEnd = (event) => {
        if (nativeScrollEnabled()) return;
        if (menu?.open || root.querySelector('.mnv-editorial-drawer > details[open]')) return;
        const deltaY = touchStartY - event.changedTouches[0].clientY;
        const deltaX = touchStartX - event.changedTouches[0].clientX;
        const screen = screens[index];
        if (screen?.classList.contains('minevre-screen--footer') && (deltaY >= 0 || screen.scrollTop > 1)) return;
        if (Math.abs(deltaY) > 55 && Math.abs(deltaY) > Math.abs(deltaX)) step(deltaY > 0 ? 1 : -1);
      };

      const onKeyDown = (event) => {
        if (nativeScrollEnabled()) return;
        if (menu?.open || root.querySelector('.mnv-editorial-drawer > details[open]')) return;
        if (event.target.closest('input, textarea, select, button, summary, [contenteditable="true"]')) return;
        const screen = screens[index];
        if (screen?.classList.contains('minevre-screen--footer')) {
          if (['ArrowDown', 'PageDown', ' ', 'End'].includes(event.key)) {
            event.preventDefault();
            screen.scrollBy({ top: event.key === 'ArrowDown' ? 40 : screen.clientHeight * .8, behavior: 'smooth' });
            return;
          }
          if (screen.scrollTop > 1 && ['ArrowUp', 'PageUp', 'Home'].includes(event.key)) {
            event.preventDefault();
            screen.scrollBy({ top: event.key === 'Home' ? -screen.scrollHeight : -screen.clientHeight * .8, behavior: 'smooth' });
            return;
          }
        }
        if (['ArrowDown', 'PageDown', ' '].includes(event.key)) { event.preventDefault(); step(1); }
        if (['ArrowUp', 'PageUp'].includes(event.key)) { event.preventDefault(); step(-1); }
        if (event.key === 'Home') { event.preventDefault(); setIndex(0); }
        if (event.key === 'End') { event.preventDefault(); setIndex(screens.length - 1); }
      };

      root.addEventListener('wheel', onWheel, { passive: false });
      root.addEventListener('touchstart', onTouchStart, { passive: true });
      root.addEventListener('touchmove', onTouchMove, { passive: false });
      root.addEventListener('touchend', onTouchEnd, { passive: true });
      document.addEventListener('keydown', onKeyDown);
      nextButton?.addEventListener('click', () => step(1));

      const desktopMenuQuery = window.matchMedia('(min-width: 990px)');
      const menuSummary = menu?.querySelector('summary');
      const menuPanel = menu?.querySelector('.minevre-menu__panel');
      const menuBackground = [stage, wordmark, root.querySelector('.minevre-header__right'), nextButton, root.querySelector('[data-immersive-pagination]')].filter(Boolean);
      let menuInertState = null;
      const setMenuModal = (active) => {
        if (active && !menuInertState) {
          menuInertState = menuBackground.map(element => [element, element.inert]);
          menuBackground.forEach(element => { element.inert = true; });
        } else if (!active && menuInertState) {
          menuInertState.forEach(([element, inert]) => { element.inert = inert; });
          menuInertState = null;
        }
      };
      let menuCloseTimer;
      let menuOpenFrame;
      const finishMenuClose = (restoreFocus = true) => {
        window.clearTimeout(menuCloseTimer);
        cancelAnimationFrame(menuOpenFrame);
        if (!menu) return;
        menu.removeAttribute('open');
        setMenuModal(false);
        menu.classList.remove('is-closing', 'is-opening');
        menuSummary?.setAttribute('aria-expanded', 'false');
        if (restoreFocus && menuSummary?.getClientRects().length) menuSummary.focus({ preventScroll: true });
      };
      const closeMenu = () => {
        if (!menu?.open || menu.classList.contains('is-closing')) return;
        cancelAnimationFrame(menuOpenFrame);
        menu.classList.add('is-closing');
        const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 420;
        menuCloseTimer = window.setTimeout(() => finishMenuClose(), delay);
      };
      menuClose?.addEventListener('click', closeMenu);
      menuSummary?.addEventListener('click', (event) => {
        event.preventDefault();
        if (!desktopMenuQuery.matches) return;
        if (menu.open) { closeMenu(); return; }
        window.clearTimeout(menuCloseTimer);
        menu.classList.add('is-opening');
        menu.open = true;
        setMenuModal(true);
        menuSummary.setAttribute('aria-expanded', 'true');
        if (menuPanel) getComputedStyle(menuPanel).transform;
        menuOpenFrame = requestAnimationFrame(() => {
          menu.classList.remove('is-opening');
          menuClose?.focus({ preventScroll: true });
        });
      });
      menu?.addEventListener('keydown', (event) => {
        if (!menu.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu();
        }
        if (event.key === 'Tab' && menuPanel) {
          const controls = [...menuPanel.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && (document.activeElement === first || !menuPanel.contains(document.activeElement))) {
            event.preventDefault(); last?.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !menuPanel.contains(document.activeElement))) {
            event.preventDefault(); first?.focus();
          }
        }
      });
      const syncDesktopMenu = () => {
        if (!desktopMenuQuery.matches) finishMenuClose(false);
        const sharedDrawer = root.querySelector('.minevre-mobile-menu header-drawer');
        if (desktopMenuQuery.matches && sharedDrawer?.isOpen) sharedDrawer.close();
      };
      desktopMenuQuery.addEventListener('change', syncDesktopMenu);

      const setupCardCarousel = (screen) => {
        const grid = screen.querySelector('.minevre-card-grid');
        if (!grid) return;
        const cards = [...grid.querySelectorAll('.minevre-card')];
        const prev = screen.querySelector('[data-card-prev]');
        const next = screen.querySelector('[data-card-next]');
        if (cards.length < 2) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }

        const currentIndex = () => Math.max(0, Math.min(cards.length - 1, Math.round(grid.scrollLeft / Math.max(grid.clientWidth, 1))));
        const syncArrows = () => {
          const cardIndex = currentIndex();
          if (prev) prev.hidden = cardIndex <= 0;
          if (next) next.hidden = cardIndex >= cards.length - 1;
        };
        const goTo = (target) => {
          const cardIndex = Math.max(0, Math.min(cards.length - 1, target));
          grid.scrollTo({ left: cardIndex * grid.clientWidth, behavior: 'smooth' });
        };

        prev?.addEventListener('click', (event) => { event.stopPropagation(); goTo(currentIndex() - 1); });
        next?.addEventListener('click', (event) => { event.stopPropagation(); goTo(currentIndex() + 1); });
        grid.addEventListener('scroll', () => window.requestAnimationFrame(syncArrows), { passive: true });
        window.addEventListener('resize', syncArrows, { passive: true });
        syncArrows();
      };

      originalScreens.filter((screen) => screen.classList.contains('minevre-screen--product-grid')).forEach(setupCardCarousel);

      /* Keep the existing next-only control for collection grids. */
      cardNextButtons.forEach((button) => {
        const screen = button.closest('[data-immersive-screen]');
        if (screen?.classList.contains('minevre-screen--product-grid')) return;
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const grid = screen?.querySelector('.minevre-card-grid');
          if (!grid) return;
          const cards = [...grid.querySelectorAll('.minevre-card')];
          if (cards.length < 2) return;
          const currentCard = Math.round(grid.scrollLeft / Math.max(grid.clientWidth, 1));
          const nextCard = (currentCard + 1) % cards.length;
          grid.scrollTo({ left: nextCard * grid.clientWidth, behavior: 'smooth' });
        });
      });

      screens.forEach((screen, screenIndex) => {
        if ('inert' in screen) screen.inert = screenIndex !== 0;
      });

      root.dataset.currentIndex = '0';
      syncLogo(0);
      root.dataset.controlsTheme = screens[0]?.dataset.theme || 'light';
      root.classList.toggle('is-footer-active', screens[0]?.classList.contains('minevre-screen--footer'));

      requestNativeScroll();

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId !== root.dataset.sectionId) return;
        finishMenuClose(false);
        desktopMenuQuery.removeEventListener('change', syncDesktopMenu);
        clearLogoBridge();
        root.classList.remove('is-return-logo-overlay');
        document.body.classList.remove('minevre-immersive-active');
        document.removeEventListener('keydown', onKeyDown);
        mobileQuery.removeEventListener('change', syncFooterGroups);
        mobileQuery.removeEventListener('change', syncResponsiveMode);
        window.removeEventListener('resize', syncResponsiveMode);
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (!root.contains(event.target)) return;
        const selected = event.target.closest('[data-immersive-screen]');
        if (selected) {
          locked = false;
          setIndex(Number.parseInt(selected.dataset.index, 10));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
